<div [outerHTML]="iconHtml">

</div>